

import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
 import {getPickupAllocated} from "../../../redux/Thunk/officePickupThunk";
import EditIcon from "../../../components/Icons/EditIcon";
import { getDrsList,deleteDrsDetails } from "../../../redux/Thunk/drsThunk";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import AllocateDialog from "../../../components/Dialogbox/AllocateDialog";
import moment from "moment/moment";
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};


const PickupPending =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [drsList, setDrsList] = useState([])
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [allocatedRows, setAllocatedRows] = useState([]);
  const [requestedId, setRequestedId] = useState(null);
  const debouncedSearch = useDebounce(search, 500);

  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })
  const officeId = useSelector((state) => state.auth.officeId);

  useEffect(()=>{
  fetchAllocated()
  },[page ,debouncedSearch])

const fetchAllocated = async () => {
  setLoader(true); 
  dispatch(getPickupAllocated({page:page.page + 1,limit:page.pageSize,search: debouncedSearch, OfficeId:officeId,isAllocated:"false"})) // API call
    .then((res) => {
      const data = res?.payload?.data; 
      setDrsList(data); // List ko state me set kiya
      setTotalCount(res?.payload?.total); // Total count set kar rahe ho
      setLoader(false); // Loader ko hata rahe ho
      const requestedIds = data.map(item => item.RequestedId);
      
    });
};
  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
     
      setSelectedRows(selectedRows);
    }
  };
 const columns = [
  {
    flex: 0.1,
    minWidth: 60,
    field: 'Sr.No',
    align: 'center',
    headerAlign: 'center',
    headerName: 'Sr. No',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center' }}>
            {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id) + 1}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.35,
    minWidth: 100,
    field: 'RequestedId',
    headerName: 'Id',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
            {row?.RequestedId || '--'}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.25,
    minWidth: 120,
    field: 'officeName',
    headerName: 'Office Name',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      const officeName = row?.OfficeDetails?.[0]?.OfficeName;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
            {officeName || '--'}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.25,
    minWidth: 150,
    field: 'PickupDateAndTime',
    headerName: 'Allocate Date & Time',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
            {moment(row?.PickupDateAndTime).format('D/M/YYYY, h:mm A')}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.35,
    minWidth: 130,
    field: 'CustomerName',
    headerName: 'Customer Name',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      const customerName = row?.Customers?.[0]?.CustomerName || '--';
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
            {customerName}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.35,
    minWidth: 130,
    field: 'Origin',
    headerName: 'Origin',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
            {row?.Origin || '--'}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.35,
    minWidth: 120,
    field: 'Destination',
    headerName: 'Destination',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
            {row?.Destination || '--'}
          </Typography>
        </Box>
      );
    }
  },
  
  {
    flex: 0.5,
    minWidth: 150,
    field: ' Status',
    headerName: 'Status',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      const isAllocated = allocatedRows.includes(row.RequestedId);
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
            {isAllocated ? 'Allocated' : 'Pending'}
          </Typography>
        </Box>
      );
    }
  },
  {
    flex: 0.14,
    minWidth: 150,
    field: 'Remark',
    headerName: 'Remarks',
    align: 'center',
    headerAlign: 'center',
    renderCell: params => {
      const { row } = params;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
            {row?.Remark || '--'}
          </Typography>
        </Box>
      );
    }
  },
  { 
    field: 'action',
    headerName: 'Action',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: params => {
      const isAllocated = allocatedRows.includes(params.row.RequestedId);
      return (
        <Button variant='contained' size='small'color={isAllocated ? 'success' : 'error'} onClick={() => {setSelectedRow(params.row); setOpenDialog(true);}}
        >
          {isAllocated ? 'Allocated' : 'Pending'}
        </Button>
      );
    }
  }
];
    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
            {/* <Header /> */}
            { loader ? <PageLoader /> : 
              <Grid container style={{padding:'0px 10px',width: '95%', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>   
               <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                  <HeaderName headerName={'Pickup Pending List'}  displaySearch = {true} newForm = {false}  onClickBackButton={()=> navigate("/dashboard")}  setSearch ={setSearch} search={search}/>
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflow: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={drsList}
                      rowHeight={55}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                       disableColumnMenu
                  disableColumnFilter
                  disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
            
<AllocateDialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  officeId={officeId}
  requestedId={selectedRow?.RequestedId}
  fetchAllocated={fetchAllocated}
  onSaveSuccess={() => {setAllocatedRows((prev) => { if (prev.includes(selectedRow.RequestedId)) return prev; 
      return [...prev, selectedRow.RequestedId]; // allocate on save
    });
    setOpenDialog(false);  // dialog close karo
  }}
  
/>

        </>
    )
}

export default PickupPending

